export const Language = {

    // Dining Page

    DiningHeader: {
        en: "Dining option",
        fr: "Dining option",
    },

    DiningPickUp: {
        en: "Pickup", 
        fr: "Pour emporter",
    },

    DiningDelivery: {
        en: "Delivery", 
        fr: "Livraison",
    },

    DiningName: {
        en: "Name", 
        fr: "Nom",
    },

    DiningEmail: {
        en: "E-mail *", 
        fr: "E-mail *",
    },

    DiningPhone: {
        en: "Phone input", 
        fr: "Numéro de téléphone",
    },

    DiningPickupTime: {
        en: "Pickup time (If later today)",
        fr: "Heure de ramassage (Si plus tard)"
    },

    DiningContinue: {
        en: "Continue",
        fr: "Continuer",
    },

    DiningNameError: {
        en: "Name field cannot be empty",
        fr: "Le champ de nom ne peut pas être vide",
    },

    DiningPhoneError: {
        en: "No phone number has been entered",
        fr: "Aucun numéro de téléphone n'a été entré",
    },

    DiningPhoneErrorLength: {
        en: "Phone length is wrong, please recheck your number",
        fr: "La longueur du téléphone est incorrecte, veuillez revérifier votre numéro",
    },

    DiningEmailError: {
        en: "Please enter your email",
        fr: "Veuillez entrer votre courriel",
    },

    DiningAddressError: {
        en: "Please enter your address",
        fr: "Veuillez entrer votre adresse",
    },

    DiningDeliveryAddress: {
        en: "Please enter your delivery address",
        fr: "Veuillez saisir votre adresse de livraison",
    },


    // Item Page

    ItemReturnToMenu: {
        en: "Return to menu",
        fr: "Revenir au menu",
    },

    ItemPrice: {
        en: "Price",
        fr: "Prix",
    },

    ItemOptions: {
        en: "Options",
        fr: "Les options",
    },

    ItemIngredients: {
        en: "Ingredients",
        fr: "Ingrédients",
    },

    ItemNotes: {
        en: "Special instructions",
        fr: "Instructions spéciales",
    },

    ItemRequiredMinimum: {
        en: "Required:",
        fr: "Requis:",
    },

    ItemRequiredMaximum: {
        en: "Required:",
        fr: "Requis:",
    },

    ItemNotifcationAddToCart: {
        en: " was added to the cart !",
        fr: " a été ajouté au panier!",
    },

    ItemEmptyOptions: {
        en: "You have to pick at least one choice in the options",
        fr: "Vous devez choisir au moins un choix dans les options",
    },

    ItemRequiredOptions: {
        en: "You have to pick at least one choice in: ",
        fr: "Vous devez choisir au moins un choix dans ",
    },

    ItemAddToCart: {
        en: "Add to cart",
        fr: "Ajouter au panier",
    },

    // Cart Page

    CartHeader: {
        en: "Cart",
        fr: "Panier"
    },

    CartIsEmpty: {
        en: "The cart is empty",
        fr: "Le panier est vide",
    },

    CartSpecialInstructions: {
        en: "Special instructions:",
        fr: "Instructions spéciales:",
    },

    CartItemDeleteMessage: {
        en: "Are you sure you want to remove the item ",
        fr: "Voulez-vous vraiment supprimer l'élément ",
    },

    CartDialogMessageRemovalYes: {
        en: "Yes",
        fr: "Oui",
    },

    CartDialogMessageRemovalNo: {
        en: "No",
        fr: "Non",
    },

    CartSubTotal: {
        en: "Sub-total:",
        fr: "Sous-total:"
    },

    CartCoupon: {
        en: "Discount:",
        fr: "Rabais:"
    },

    CartTax: {
        en: "Taxes:",
        fr: "Taxes:",
    },

    CartTotal: {
        en: "Total:",
        fr: "Totale:",
    },

    CartProceedToCheckout: {
        en: "Proceed to checkout",
        fr: "Procéder au paiement",
    },

    // Review Order

    ReviewOrderHeader: {
        en: "Review order",
        fr: "Revoir la commande",
    },

    ReviewOrderYourInformation: {
        en: "Your information",
        fr: "Vos informations",
    },

    ReviewOrderName: {
        en: "Name", 
        fr: "Nom",
    },

    ReviewOrderPhone: {
        en: "Phone input", 
        fr: "Numéro de téléphone",
    },

    ReviewOrderPickupTime: {
        en: "Pickup Time",
        fr: "Heure de ramassage",
    },

    ReviewOrderPayment: {
        en: "Payment modality",
        fr: "Modalité de paiement",
    },

    ReviewOrderPaymentCash: {
        en: "Cash in person",
        fr: "Argent comptant",
    },

    ReviewOrderPaymentDelivery: {
        en: "Pay at the door",
        fr: "Payer à la porte",
    },

    ReviewOrderPaymentStore: {
        en: "Pay at the store",
        fr: "Payer au magasin",
    },

    ReviewOrderPaymentCreditCard: {
        en: "Credit card",
        fr: "Carte de crédit",
    },

    ReviewOrderComingSoon: {
        en: "( Coming soon )",
        fr: "( Bientôt disponible )"
    },

    ReviewOrderMinimumOrder: {
        en: "Minimum order amount is: ",
        fr: "Le montant minimum de commande est: ",
    },

    ReviewOrderPlaceOrder: {
        en: "PLACE MY ORDER: ",
        fr: "PASSER MA COMMANDE: ",
    },

    // Order Confirmation

    OrderConfirmationHeader: {
        en: "Order Complete",
        fr: "Commande terminée",
    },

    OrderConfirmationComplete: {
        en: "Return to main menu",
        fr: "Revenir au menu principal",
    },

    OrderConfirmationButton: {
        en: "Return to the main page",
        fr: "Retour à la page principale",
    },

    // Payment Page
    
    PaymentPageHeader:{
        en: "Payment",
        fr: "Payment",
    },
    
    PaymentPageSubTotal: {
        en: "Sub-total:",
        fr: "Sous-total:"
    },

    PaymentPageTax: {
        en: "Taxes:",
        fr: "Taxes:",
    },

    PaymentPageTotal: {
        en: "Total:",
        fr: "Totale:",
    },

    PaymentPagePayButton: {
        en: "Pay",
        fr: "Payer",
    },

}